module.exports = __webpack_public_path__ + "media/images/athletes/528-417fbbb3c21f68ffdfe8693eaeff365e.png";